import * as echarts from 'echarts'
import { useEffect, useRef } from 'react'
import styled from 'styled-components'

export type SmoothLineChartData = {
  [key: string]: string
}

type SmoothLineChartProps = {
  title?: string
  data: SmoothLineChartData[] | undefined
  height?: number | string
  width?: number | string
}

const toCssSize = (size?: number | string) =>
  typeof size === 'number' ? `${size}px` : size || '100%'

const SmoothLineChartWrapper = styled.div<Partial<SmoothLineChartProps>>`
  width: ${(props) => toCssSize(props.width)};
  height: ${(props) => toCssSize(props.height)};
  min-height: 0;
`

export const RECLineChart = <T extends SmoothLineChartProps>(
  smoothLineChartProps: T
): React.ReactElement => {
  const chartDom = useRef<HTMLDivElement>(null)
  const { title, data, height = '100%', width = '100%' } = smoothLineChartProps

  const seriesLandAvgPrc = data?.map((item) => [item.date, item.landAvgPrc])
  const seriesJejuAvgPrc = data?.map((item) => [item.date, item.jejuAvgPrc])

  useEffect(() => {
    if (chartDom.current) {
      const chartInstance = echarts.init(chartDom.current)
      chartInstance.setOption({
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'time',
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '육지',
            data: seriesLandAvgPrc,
            type: 'line',
            smooth: true,
          },
          {
            name: '제주도',
            data: seriesJejuAvgPrc,
            type: 'line',
            smooth: true,
          },
        ],
      })

      const resizeObserver = new ResizeObserver(() => {
        chartInstance.resize()
      })
      resizeObserver.observe(chartDom.current)

      return () => {
        resizeObserver.disconnect()
        chartInstance.dispose()
      }
    }
  }, [title, seriesLandAvgPrc, seriesJejuAvgPrc])

  return (
    <SmoothLineChartWrapper width={width} height={height}>
      <div
        id="smooth-line-chart"
        ref={chartDom}
        style={{ width: width, height: height }}
      />
    </SmoothLineChartWrapper>
  )
}
